import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col, Form, Button,Breadcrumb } from "react-bootstrap";

import { PageLinks } from "../../common/page-links";
import TeamCard from "../OurTeam/TeamCard"
import "../../scss/branch-contact.scss";
import "./ContactForm.scss";

import FormsWrapper from "../FormPage/FormPage";

const ContactForm = ({data}) => {

    return (
        <React.Fragment>
            <section className="breadcrumb-section">
                <Container>
                    <Row>
                        <Col>
                            <ol class="breadcrumb d-flex d-md-none">
                                <li class="breadcrumb-item"><Link to={`/${PageLinks.teams}/`} role="button">Back to Teams</Link></li>
                            </ol>

                            <ol class="breadcrumb d-none d-md-flex">
                                {/* <li class="breadcrumb-item d-none"><Link to={`/${PageLinks.teams}/`} role="button">Back to Teams</Link></li> */}

                                <li class="breadcrumb-item"><Link to={"/"} role="button" tabindex="0">Home</Link></li>
                                <li class="breadcrumb-item"><Link to={`/${PageLinks.about}/`} role="button" tabindex="0">About</Link></li>
                                <li class="breadcrumb-item"><Link to={`/${PageLinks.teams}/`} role="button" tabindex="0">Meet the Team</Link></li>
                                <li class="breadcrumb-item last-item"><a href={`javascript:;`} role="button">{data?.name}</a></li>
                                <li class="breadcrumb-item d-none d-md-block last-item"><a href="javascript:;">Contact Us</a></li>
                            </ol>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="contact-form">
                <Container>
                    <Row>
                        <Col md={12} lg={8} className="col-left">
                            <FormsWrapper form_data={{title:`Contact ${data?.name}`, content:""}} to_email_id={data?.email} form_type={"staff_contact"} staff_name={data?.name}/>
                        </Col>
                        <Col md={12} lg={4} className="col-right right_sec">
                            {/* <div className="timing">
                                {data?.address && 
                                    <div className="time-wrap ">
                                        <h4>Branch Address</h4>
                                        <address>{data?.address}</address>
                                    </div>
                                }

                                <div className="time-wrap ">
                                    <h4>Contact Details</h4>
                                    {data?.mobile && <a href={`tel:${data.mobile}`} className="tel"> {data.mobile}</a>}

                                    {data?.email && <a className="mail" href="javascript:;">Email Us</a>}
                                </div>

                                {data?.opening_hours?.length > 0 && 
                                <div className="time-wrap last-wrap">
                                    <h4>Opening Hours</h4>
                                    <div className="hours">
                                        {data?.opening_hours?.map((item, index) => {
                                            return(
                                                <div className="day-wrap">
                                                    <span>{item.name}: </span>
                                                    <span> {item.value}</span>
                                                </div>
                                            )}
                                        )}
                                    </div>
                                </div>
                                }

                            </div> */}
                            <TeamCard TeamList={data} type="contact_form" />
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default ContactForm;